export class PlanModel {

  constructor({ id, name = '', price, duration, description_items = [] } = {}) {
    this.id = id;
    this.name = name;
    this.price = price;
    this.duration = duration;
    this.description_items = description_items;
    this._apiAttributes = {
      name: 'name',
      price: 'price',
      duration: 'duration',
    };
  }

  getApiData() {
    return {
      id: this.id,
      name: this.name,
      price: this.price,
      duration: this.duration,
      description_items: this.description_items.filter( ({description}) => !!description )
    };
  }

  addNewDescriptionItem() {
    this.description_items.push({description: ''});
  }

  removeDescriptionItem(index) {
    this.description_items.splice(index, 1);
  }

  validate (validator) {
    validator.resetFields();
    return validator.isValid();
  }
}
